import jsx from '../jsx';
import { extractFromTable, getElementsByClassName } from '../utils';

document.addEventListener('DOMContentLoaded', async () => {
  const target = getElementsByClassName<HTMLDivElement>('fleet')?.[0];

  if (target) {
    const table = target.getElementsByTagName('table')[0];
    const data = extractFromTable<{ id: string; name: string; level: string }>(
      table,
    );

    target.innerHTML =
      "At some point I'll make a cool graphic here showing my collection.";
  }
});
